const AssignmentRole = {
  CRX: 'CRX',
  ASSISTANT_COACH: 'AC',
  COACH: 'Coach',
  INSIDE_SALES: 'IS',
  CAM: 'CAM',
  CPS: 'CPS',
  POOL: 'POOL',
};

const ConflictingRole = {
  [AssignmentRole.ASSISTANT_COACH]: AssignmentRole.POOL,
  [AssignmentRole.POOL]: AssignmentRole.ASSISTANT_COACH,
};

export {
  AssignmentRole,
  ConflictingRole,
};
